// Our intraday swing levels are named SH/SL (swing high/low) so they don't read as pivot points,
// which is what R1/S1 mean on Groww and TradingView. (The data keeps R1/R2/S1/S2 as keys.)
export const SWING: Record<'R1' | 'R2' | 'S1' | 'S2', string> = { R1: 'SH1', R2: 'SH2', S1: 'SL1', S2: 'SL2' };
